const getProductUrl = (url, productPageUrl) => {
  return `${productPageUrl}${url}`.replace("//", "/");
};
export default getProductUrl;
